import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';

const Stars = ({ value, onPick }) => (
    <span className={`bp-stars-row ${onPick ? 'pickable' : ''}`} role={onPick ? 'radiogroup' : undefined}>
        {[1, 2, 3, 4, 5].map(n => (
            <span
                key={n}
                className={n <= value ? 'on' : ''}
                onClick={onPick ? () => onPick(n) : undefined}
                role={onPick ? 'radio' : undefined}
                aria-checked={onPick ? n === value : undefined}>
                ★
            </span>
        ))}
    </span>
);

export default function ReviewSection({ seller }) {
    const [msg, setMsg] = useState('');
    const [value, setValue] = useState(0);
    const [sending, setSending] = useState(false);
    const [posted, setPosted] = useState([]);      // optimistic additions
    const token = localStorage.getItem('token');
    const user = useSelector(state => state.user);

    const reviews = [...posted, ...(seller.reviews || [])];
    const avg = reviews.length
        ? (reviews.reduce((s, r) => s + (r.rating || 0), 0) / reviews.length).toFixed(1)
        : null;

    const submit = (e) => {
        e.preventDefault();
        if (!token) { toast.info('Log in to leave a review'); return; }
        if (!value) { toast.warn('Pick a star rating first'); return; }
        if (!msg.trim()) { toast.warn('Write a few words about your experience'); return; }
        setSending(true);
        axios.post(`${process.env.REACT_APP_APP_API_URL}/api/review`, {
            reviewed: seller._id,
            reviewer: user._id,
            msg, type: 2, rating: value,
        }, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
            if (response.data.status) {
                toast.success('Review posted — thank you!');
                setPosted(p => [{ msg, rating: value, createdAt: new Date().toISOString(), mine: true }, ...p]);
                setMsg(''); setValue(0);
            } else {
                toast.error(response.data.message || 'Could not post the review');
            }
        }).catch(() => toast.error('Could not post the review')).finally(() => setSending(false));
    }

    return (
        <div className="bp-panel" style={{ padding: '26px' }}>
            <div className="bp-reviews-head">
                <div>
                    <h3 className="bp-reviews-title">Reviews</h3>
                    {avg
                        ? <span className="bp-dim"><Stars value={Math.round(avg)} /> {avg} · {reviews.length} review{reviews.length === 1 ? '' : 's'}</span>
                        : <span className="bp-dim">No reviews yet — be the first.</span>}
                </div>
            </div>

            <form className="bp-review-form" onSubmit={submit}>
                <div className="bp-review-form-top">
                    <span className="bp-dim">Your rating:</span>
                    <Stars value={value} onPick={setValue} />
                </div>
                <textarea
                    className="bp-auth-input"
                    rows={3}
                    placeholder="How was your experience with this shop?"
                    value={msg}
                    onChange={e => setMsg(e.target.value)}
                />
                <button type="submit" className="bp-btn-primary" disabled={sending}>
                    {sending ? 'Posting…' : 'Post Review'}
                </button>
            </form>

            <div className="bp-review-list">
                {reviews.map((r, i) => (
                    <div className="bp-review-item" key={r._id || `p${i}`}>
                        <div className="bp-review-item-head">
                            <Stars value={r.rating || 0} />
                            <span className="bp-dim">
                                {r.mine ? 'You · just now' : (r.createdAt ? moment(r.createdAt).format('MMM D, YYYY') : '')}
                            </span>
                        </div>
                        <p>{r.msg}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}
